module.exports = __webpack_public_path__ + "img/mtitle.10236a0b.png";